export default __webpack_public_path__ + "static/media/twitter.ce8960f6.svg";